var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"wrap":"","justify-center":"","text-center":""}},[_c('v-flex',[_c('v-container',[_c('video',{ref:"video",attrs:{"height":"800px","autoplay":""}},[_c('source',{attrs:{"src":_vm.video,"type":"video/mp4"}})])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }